module.exports = __webpack_public_path__ + "img/logo-kolobox.fff5e8f1.png";